import http from "./http"
import queryString from "@/utils/queryString"
import getParamsFromUrl from "@/utils/getParamsFromUrl"
import { apiUrl } from "@/config"
// import readFile from "@/utils/readFile"
// import qs from "qs"

export const getActivityDetail = ({ params = {}, finalFunc = null, showLoading = true } = {}) => {
  let { type } = getParamsFromUrl()
  const url = `/activity/${type === "preview" ? "preview" : "details"}/${params.id}`
  return http.post({ url, params: {}, finalFunc, showLoading })
}

export const getWorksList = ({ params = {}, finalFunc = null, showLoading = true } = {}) => {
  const queryStr = queryString(params)
  const url = `/works/list?${queryStr}`
  return http.post({ url, params: {}, finalFunc, showLoading })
}

export const getmyWorksList = ({ params = {}, headers = {}, finalFunc = null, showLoading = true } = {}) => {
  // const url = `/works/myWorks`
  const url = `/works/myWorks?activityId=${params.activityId}&page=${params.page}&size=${params.size}`
  return http.post({ url, params, headers, finalFunc, showLoading })
}

export const getRegionData = ({ params = {}, finalFunc = null, showLoading = false, requestType = "file" } = {}) => {
  const url = `/static/region/region.json`
  return http.get({ url, params, finalFunc, showLoading, requestType })
}

export const uploadImg = ({
  params = {},
  headers = {},
  finalFunc = null,
  showLoading = false,
  onUploadProgress = null,
  cancelToken = null,
  timeout = null
} = {}) => {
  const url = `/file/uploadImage`
  return http.post({ url, params, headers, timeout, finalFunc, showLoading, onUploadProgress, cancelToken })
}

export const commitInfo = ({ params = {}, headers = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/works/save`
  return http.post({ url, params, headers, finalFunc, showLoading })
}

export const modifyInfo = ({ params = {}, headers = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/works/modify`
  return http.post({ url, params, headers, finalFunc, showLoading })
}

export const registUserInfo = ({ params = {}, headers = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/user/save`
  return http.post({ url, params, headers, finalFunc, showLoading })
}

//作品点赞
export const getThumbers = ({ params = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/works/addLike`
  return http.post({ url, params, finalFunc, showLoading })
}

//根据活动获取用户信息
export const getuserdelit = ({ params = {}, headers = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/user/detailsByActivityId/${params.activityId}`
  return http.post({ url, params, headers, finalFunc, showLoading })
}

export const getUserDetail = ({ params = {}, headers = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/user/detailsByActivityId/${params.activityId}`
  return http.post({ url, params, headers, finalFunc, showLoading })
}

export const searchSchool = ({ params = {}, headers = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/school/complete/search?keyword=${params.keyword}`
  return http.post({ url, params, headers, finalFunc, showLoading })
}

export const worksPraise = ({ params = {}, headers = {}, finalFunc = null, showLoading = true, showToast = false } = {}) => {
  const bodyParams = {
    nvcVal: window.getNVCVal()
  }
  const queryStr = queryString(params)
  const url = `/works/addLike?${queryStr}`
  return http.post({ url, params: bodyParams, headers, finalFunc, showLoading, showToast, interceptError: false })
}

export const getWorkDetail = ({ params = {}, headers = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/works/details/${params.id}`
  return http.post({ url, params, headers, finalFunc, showLoading })
}

export const getReplenishWorksType = ({ params = {}, headers = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/works/replenish/worksType`
  return http.post({ url, params, headers, finalFunc, showLoading })
}

export const getAdDetail = ({ params = {}, headers = {}, finalFunc = null, showLoading = true, showToast = false } = {}) => {
  const url = `/ad/detail`
  return http.get({ url, params, headers, finalFunc, showLoading, showToast })
}

export const getWorkCollection = ({ params = {}, headers = {}, finalFunc = null, showLoading = true, showToast = false } = {}) => {
  const url = `/works/selected`
  return http.get({ url, params, headers, finalFunc, showLoading, showToast })
}

export const uploadVideo = async ({
  params = {},
  headers = {},
  finalFunc = null,
  showLoading = false,
  onUploadProgress = null,
  cancelToken = null,
  timeout = null
} = {}) => {
  const url = `/file/uploadVideo`
  return http.post({ url, params, headers, timeout, finalFunc, showLoading, onUploadProgress, cancelToken })
}

export const getUserInfo = ({ params = {}, headers = {}, finalFunc = null, showLoading = true, showToast = false } = {}) => {
  const url = `/user/userId/${params.userId}`
  return http.get({ url, params, headers, finalFunc, showLoading, showToast })
}

export const uploadVideoChunk = ({
  params = {},
  headers = {},
  finalFunc = null,
  showLoading = false,
  onUploadProgress = null,
  cancelToken = null,
  timeout = null,
  showToast = true
} = {}) => {
  const url = `/file/upload/video/chunk`
  return http.post({ url, params, headers, timeout, finalFunc, showLoading, onUploadProgress, cancelToken, showToast })
}

export const mergeVideo = ({ params = {}, headers = {}, finalFunc = null, showLoading = false, showToast = true } = {}) => {
  const url = `/file/merge/video`
  return http.post({ url, params, headers, finalFunc, showLoading, showToast })
}

export const getGradeList = ({ params = {}, headers = {}, finalFunc = null, showLoading = false, showToast = true } = {}) => {
  const url = `/draw/GradeVoEnum`
  return http.get({ url, params, headers, finalFunc, showLoading, showToast })
}

export const getMyWorkDetail = ({ params = {}, headers = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/works/private/details/${params.id}`
  return http.post({ url, params, headers, finalFunc, showLoading })
}

export const searchUnit = ({ params = {}, headers = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/companyRel/list/company`
  return http.get({ url, params, headers, finalFunc, showLoading })
}

export const getCertGroup = ({ params = {}, headers = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/certGroup/list`
  return http.get({ url, params, headers, finalFunc, showLoading })
}

export const getCertTipsCount = ({ params = {}, headers = {}, finalFunc = null, showLoading = false, showToast = false } = {}) => {
  const url = `/cert/certTips`
  return http.get({ url, params, headers, finalFunc, showLoading, showToast })
}

export const getCertDetail = ({ params = {}, headers = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/cert/id`
  return http.get({ url, params, headers, finalFunc, showLoading })
}

export const getMyCert = ({ params = {}, headers = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/cert/list/user`
  return http.get({ url, params, headers, finalFunc, showLoading })
}

export const getMyContribute = ({ params = {}, headers = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/works/myWorksSummary`
  return http.get({ url, params, headers, finalFunc, showLoading })
}

export const getContributeSummary = ({ params = {}, headers = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/user/summary/uuid`
  return http.get({ url, params, headers, finalFunc, showLoading })
}

export const getNativeActivityTabList = ({ params = {}, headers = {}, finalFunc = null, showLoading = false } = {}) => {
  const url = `${apiUrl}/activity/online/column`
  return http.get({ url, params, headers, finalFunc, showLoading })
}
